import { Component, Input } from '@angular/core';
import { ModalUtilsService } from 'src/app/services/modal-utils.service';
import { TabUtilsService } from 'src/app/services/tab-utils.service';
import { UserGroupsService } from 'src/app/services/user-groups/user-groups.service';
import { UserRolesService } from 'src/app/services/user-roles/user-roles.service';

@Component({
  selector: 'bpc-groups-column',
  templateUrl: './groups-column.component.html',
  styleUrl: './groups-column.component.scss'
})
export class GroupsColumnComponent {
  @Input() row!: any;

  constructor(
    private modalUtilsService: ModalUtilsService,
    private userGroupsService: UserGroupsService,
    private userRolesService: UserRolesService,
    private tabUtilsService: TabUtilsService
  ){

  }
  addOrEditUser(user: any = null) {
    let modalParameters = this.modalUtilsService.modalParameters;
    if (user) {
      modalParameters.currentModalAction = "EditUser";
      modalParameters.name = user.name;
      modalParameters.initials = user.initials;
      modalParameters.email = user.email;
      modalParameters.externalId = user.externalId;
      modalParameters.base64Image = user.profilePictureUrl ?? "";
      const userGroupIds = user.userGroups.map((group: any) => {
        return group.groupId;
      });
      const userRoleIds = user.userRoles.map((role: any) => {
        return role.roleId;
      });
      const userPodsIds = user.userGroups.map((group: any) => {
        return group.groupId;
      });
      const selectedGroups = this.userGroupsService.userGroups.filter((group) => {
        return userGroupIds.includes(group.id);
      });
      modalParameters.externalId = user.externalId;
      modalParameters.userGroups = selectedGroups;
      const selectedRoles = this.userRolesService.userRoles.filter((role) => {
        return userRoleIds.includes(role.roleId);
      });
      modalParameters.userRoles = selectedRoles;
      modalParameters.userId = user.id;
      modalParameters.isActive = user.isActive;
    } else {
      modalParameters.currentModalAction = "AddUser";
    }

    this.modalUtilsService.toggalModal.next(modalParameters);
  }
  handleUserStatus(status: any, user: any) {
    let modalParameters = this.modalUtilsService.modalParameters;
    if (status.checked) {
      modalParameters.currentModalAction = "UserActiveToggle";
    } else {
      modalParameters.currentModalAction = "UserInactiveToggle";
    }
    modalParameters.userId = user.id;
    modalParameters.userStatus = status.checked;
    this.modalUtilsService.toggalModal.next(modalParameters);
    this.tabUtilsService.refreshData.next();
  }

}
